import { render, staticRenderFns } from "./ProductsTableSkeleton.vue?vue&type=template&id=0fc344aa&scoped=true&"
import script from "./ProductsTableSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ProductsTableSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsTableSkeleton.vue?vue&type=style&index=0&id=0fc344aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc344aa",
  null
  
)

export default component.exports